function ParseUrl(url) {
  if (url.match(/^(GET|POST|DELETE|PATCH):/)) {
    let parts = url.split(':')
    return { method: parts.at(0), url: parts.slice(1).join(':') }
  }

  return { method: 'POST', url }
}

export { ParseUrl }
